export default path => (path && path.lastIndexOf('/', 0) ? `/${path}` : path)



// WEBPACK FOOTER //
// ./src/utils/prependSlashMaybe.js